import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KnBrOrderToolsModule } from "./kn-br-cart/kn-br-order-tools/kn-br-order-tools.module";
import { KnBrDraftOrderModule } from "./kn-br-cart/saved-carts/components/kn-br-draft-order/kn-br-draft-order.module";
import { KnBrQuoteModule } from "./kn-br-cart/saved-carts/components/kn-br-quote/kn-br-quote.module";
import { KnBrServiceTicketsModule } from "./kn-br-customer-ticketing/components/kn-br-service-tickets/kn-br-service-tickets.module";
import { KnBrMyQuoteModule } from "./kn-br-my-customer/kn-br-my-quotes/kn-br-my-quote.module";

@NgModule({
  imports: [
    CommonModule,
    KnBrOrderToolsModule,
    KnBrDraftOrderModule,
    KnBrQuoteModule,
    KnBrServiceTicketsModule,
    KnBrMyQuoteModule,
  ],
})
export class KnBrFeaturesLibsModule { }
